/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconGridFrame16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconGridFrame16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.139 1.556c.265-.11.57-.166.983-.195.415-.028.935-.028 1.633-.028h4.49c.698 0 1.218 0 1.632.028.414.029.718.085.983.195a2.925 2.925 0 0 1 1.584 1.583c.11.265.166.57.194.983.028.415.028.935.028 1.633v4.49c0 .698 0 1.218-.028 1.632-.028.414-.084.718-.194.983a2.925 2.925 0 0 1-1.584 1.584c-.265.11-.569.166-.983.194-.414.028-.934.028-1.633.028H5.755c-.698 0-1.218 0-1.633-.028-.414-.028-.718-.084-.983-.194a2.925 2.925 0 0 1-1.583-1.584c-.11-.265-.166-.569-.195-.983-.028-.414-.028-.934-.028-1.633V5.755c0-.698 0-1.218.028-1.633.029-.414.085-.718.195-.983a2.926 2.926 0 0 1 1.583-1.583Zm2.616 1.139c-.717 0-1.183 0-1.54.025-.345.023-.483.064-.555.094-.613.254-.923.782-.965 1.4v6.845h.002l-.003.19c-.002.134-.005.277 0 .415.007.233.035.47.12.675.159.383.463.688.846.846.072.03.21.07.555.094.357.025.823.026 1.54.026h1.564V2.695H5.755Zm2.926 0v4.624h4.624V5.755c0-.717-.001-1.183-.026-1.54-.023-.345-.064-.483-.094-.555a1.564 1.564 0 0 0-.846-.846c-.072-.03-.21-.07-.554-.094-.358-.024-.824-.025-1.54-.025H8.68Zm0 5.986v4.624h1.563c.717 0 1.183-.001 1.54-.026.345-.023.483-.064.555-.094.383-.158.688-.463.846-.846.03-.072.07-.21.094-.554.025-.358.026-.824.026-1.54V8.68H8.68Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconGridFrame24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconGridFrame24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.709 2.334c.398-.165.854-.25 1.475-.292C6.805 2 7.586 2 8.633 2h6.734c1.047 0 1.828 0 2.45.042.62.043 1.076.127 1.474.292a4.388 4.388 0 0 1 2.375 2.375c.165.398.25.854.291 1.475C22 6.805 22 7.586 22 8.633v6.734c0 1.047 0 1.828-.043 2.45-.042.62-.126 1.076-.291 1.474a4.388 4.388 0 0 1-2.375 2.375c-.398.165-.854.25-1.474.291-.622.043-1.403.043-2.45.043H8.633c-1.047 0-1.828 0-2.45-.043-.62-.042-1.076-.126-1.474-.291a4.388 4.388 0 0 1-2.375-2.375c-.165-.398-.25-.854-.292-1.474C2 17.195 2 16.414 2 15.367V8.633c0-1.047 0-1.828.042-2.45.043-.62.127-1.076.292-1.474a4.388 4.388 0 0 1 2.375-2.375Zm3.924 1.709c-1.075 0-1.774 0-2.31.037-.517.036-.724.097-.832.141-.92.381-1.385 1.174-1.448 2.102V16.59h.002l-.003.283c-.004.202-.008.417-.001.623.011.35.053.705.18 1.013a2.346 2.346 0 0 0 1.27 1.27c.108.044.315.105.832.14.536.037 1.235.038 2.31.038h2.346V4.043H8.633Zm4.388 0v6.936h6.936V8.633c0-1.075 0-1.774-.037-2.31-.036-.517-.097-.724-.141-.832a2.346 2.346 0 0 0-1.27-1.27c-.108-.044-.315-.105-.832-.14-.536-.037-1.235-.038-2.31-.038h-2.346Zm0 8.978v6.936h2.346c1.075 0 1.774 0 2.31-.037.517-.036.724-.097.832-.141a2.346 2.346 0 0 0 1.27-1.27c.044-.108.105-.315.14-.832.037-.536.038-1.235.038-2.31v-2.346h-6.936Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconGridFrame = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconGridFrame(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconGridFrame16 {...iconProps} />;
        case '24':
            return <IconGridFrame24 {...iconProps} />;
        default:
            return <IconGridFrame24 {...iconProps} />;
    }
});
